import { render, staticRenderFns } from "./NormalSearchNav327.vue?vue&type=template&id=65944788&scoped=true"
import script from "./NormalSearchNav327.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav327.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65944788",
  null
  
)

export default component.exports